export class TransitionModel {
    id: string;
    institutionId: string;
    isFellowshipProgram: boolean;
    fellowshipProgramName: string;
    fellowshipProgramLocation: string;
    fellowshipProgramSubspecialty: string;
    fellowshipBeginDate: Date;
    fellowshipEndDate: Date;
    nonInstitutionalEmailAddress: string;

    public constructor(init?: Partial<TransitionModel>) {
        Object.assign(this, init);
    }
}
